var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d7fa07f5b7ded4573b3a14eb9cba05d8ae0f12e2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blog@yesware"]={id:"d7fa07f5b7ded4573b3a14eb9cba05d8ae0f12e2"};
      